// Minimal JavaScript pack for webinar register/join pages.
// Keep startup sequential: ESM imports are hoisted above CommonJS requires.

const $ = require("jquery");
global.$ = $;
global.jQuery = $;

require("@rails/ujs").start();
require("../lib/slick");

// Every Stimulus controller the funnel views actually reference must be registered
// here. application.js gets them for free via require("controllers"), which pulls the
// whole directory in through require.context — this pack cannot do that without
// dragging the product-only controllers (and their select2 / trix / chat imports) back
// into the bundle the trim was meant to shrink. So the list is explicit, and it has to
// be kept in step with the views.
//
// It went out of step once already: only send-event was registered, which silently
// disabled the conditional follow-up questions in the registration modal. Selecting
// "Design Studio / Small Company" is supposed to reveal team size and revenue; with
// qualification-select unregistered nothing appeared and every lead came in without
// those answers. The markup and the controller were both correct — only the wiring
// was missing, which is why it produced no console error.
//
// Current usage (grep 'data-controller' under app/views/{webinars,shared,home,layouts}):
//   send-event ............ register / join / webinars#index view beacons
//   qualification-select .. shared/_qualification_questions conditional follow-ups
//   moreless .............. {home,shared}/_more_less_template expanders
//   app-redirect .......... layouts/_app_download_cta dismiss
// All four import nothing beyond "stimulus", so registering them costs no bundle size.
const { Application } = require("stimulus");
const SendEventController = require("../controllers/send_event_controller").default;
const QualificationSelectController =
  require("../controllers/qualification_select_controller").default;
const MorelessController = require("../controllers/moreless_controller").default;
const AppRedirectController = require("../controllers/app_redirect_controller").default;

const application = Application.start();
application.register("send-event", SendEventController);
application.register("qualification-select", QualificationSelectController);
application.register("moreless", MorelessController);
application.register("app-redirect", AppRedirectController);

$(document).ready(function () {
  var navBarToggler = $(".navbar-toggler");
  navBarToggler.on("click", function () {
    navBarToggler.toggleClass("active");
  });

  $(".flash-alert").delay(10000).fadeOut(800);

  if ($(".box-notify").length) {
    setTimeout(function () {
      $(".box-notify").fadeIn("slow");
    }, 10000);
    setTimeout(function () {
      $(".box-notify").fadeOut("slow");
    }, 25000);
  }

  if (typeof Plyr !== "undefined" && document.getElementById("custom_player")) {
    new Plyr("#custom_player");
  }
});
